<div class="ag-selection-checkbox">
  <div
    class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
    [ngClass]="[isAllSelected ? 'ag-checked' : '']"
  >
    <input
      id="select-all-alert-orders"
      type="checkbox"
      class="select-all ag-input-field-input ag-checkbox-input"
      [checked]="isAllSelected"
      (change)="toggleSelect()"
    />
  </div>
</div>
